var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left red-underline-animation pb-4"},[_c('router-link',{staticClass:"inverted--text opaque-underline",attrs:{"to":_vm.to}},[_vm._t("default"),_vm._v("→ ")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }